import PageHeader from "@/components/PageHeader";
import Pillars from "@/components/Pillars";
import Reveal from "@/components/Reveal";
import FoundersLetter from "@/components/FoundersLetter";
import EmailCaptureCTA from "@/components/EmailCaptureCTA";

const ABOUT_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_the-literary-room/artifacts/a86ssrd4_8B2E0001-ABD0-42C1-855C-E1D53DE00B9D.jpg";
const values = ["Literary Exploration", "Meaningful Conversation", "Sisterhood", "Personal Growth", "Culture", "Community", "Beautiful Shared Experiences"];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader overline="Our Story" script="This is your room." title="This Is More Than a Book Club." subtitle="The Mahogany Room is a curated community and safe, welcoming space for Black women to read deeply, connect authentically, and gather around literature, culture, and shared experiences." />

      <section className="py-24 bg-mahogany-900">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 border border-gold/30 rounded-sm" />
              <img src={ABOUT_IMG} alt="Mahogany Room members gathered for a reading night" className="relative w-full rounded-sm object-cover aspect-[4/3]" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="overline mb-4">Why We Exist</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-cream mb-6 leading-tight">An Intentional Space, Built With Love</h2>
            <p className="text-cream/70 leading-relaxed mb-6 font-light">
              You asked for a space to read, connect, grow, and have real conversations with dope women who love good books — so we created The Mahogany Room. It's sophisticated, warm, feminine, and intimate, like entering an elegant private reading lounge.
            </p>
            <p className="text-cream/70 leading-relaxed mb-8 font-light">Everything we do is centered around:</p>
            <div className="flex flex-wrap gap-3">
              {values.map((v) => (
                <span key={v} className="px-4 py-2 border border-gold/30 rounded-full text-cream/80 text-sm" data-testid={`value-${v.toLowerCase().replace(/ /g, "-")}`}>{v}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-b from-mahogany-950 to-mahogany-900">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="text-center mb-16">
            <p className="overline mb-4">What We're About</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-cream">Our Four Pillars</h2>
          </Reveal>
          <Pillars />
        </div>
      </section>

      <FoundersLetter />

      <EmailCaptureCTA />
    </div>
  );
}
